import bucketIcon from '../brand/generated/popover/delete.svg';

export const iconBucket = () => bucketIcon;
